// extracted by mini-css-extract-plugin
export default {"group":"ChipGroup_group__J4QI8","label":"ChipGroup_label__xlfJy","chips":"ChipGroup_chips__91s1o"};